import { type ClientHeatmapReport } from '@/features/reports/api';
import { HEATMAP_COPY } from '@/features/reports/copy';
import { HeatGrid, Legend } from '@/features/reports/heatmap/HeatGrid';
import { weekRange } from '@/features/reports/heatmap/labels';
import { ReportCard } from '@/features/reports/parts';

const COPY = HEATMAP_COPY.demand;

/**
 * Brand and category demand (ALS-88): the brands with the most demand against the primary
 * categories they have it in, each cell the window's product views plus order lines, on its own
 * ramp against its own busiest cell. Not per client, so the manager does not narrow it.
 */
export function DemandCard({ report }: { report: ClientHeatmapReport }) {
    const { categories, brands } = report.demand;
    return (
        <ReportCard title={COPY.title} subtitle={COPY.subtitle(weekRange(report))}>
            {brands.length === 0 ? (
                <p className="text-muted-foreground py-4 text-sm">{COPY.empty}</p>
            ) : (
                <>
                    <HeatGrid
                        label={COPY.title}
                        rowHead={COPY.brand}
                        columns={categories.map((c) => c.name)}
                        tone="demand"
                        cellLabel={COPY.cell}
                        emptyLabel={COPY.none}
                        rows={brands.map((brand) => ({
                            key: String(brand.brandId),
                            name: brand.name,
                            header: brand.name,
                            scores: brand.scores,
                        }))}
                    />
                    <Legend tone="demand" low={COPY.legend.low} high={COPY.legend.high} />
                </>
            )}
        </ReportCard>
    );
}
